/*global document, window */

import ReactDOM from 'react-dom';
import "./public/css/order.css";
import "./public/css/lib/font-awesome.min.css"
import "./public/css/lib/hoverdir.css"
import "./public/css/lib/imagegrid.css"
import "./public/css/lib/justifiedGallery.min.css"
import  "./public/css/lib/lightbox.min.css"
import  "./public/css/lib/wo-map-extend.css"
import 'react-loading-skeleton/dist/skeleton.css'

require('es6-promise').polyfill();
import { createElementWithContext } from 'fluxible-addons-react';
import { debugOnClient } from './frontend/clientDebug'
import app from './app';


const dehydratedState = window.App; // Sent from the server

window.React = ReactDOM; // For chrome dev tool support


// pass in the dehydrated server state from server.js
app.rehydrate(dehydratedState, (err, context) => {
    if (err) {
        throw err;
    }
    window.context = context;
    const mountNode = document.getElementById('app');

    debugOnClient('React Rendering');
    ReactDOM.hydrate(
        createElementWithContext(context),
        mountNode,
        () => debugOnClient('React Rendered')
    );
});
